// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__15Mfu","title":"Header_title__2syoC","side":"Header_side__1N-Wh"};